import React, { useState, useRef, useEffect } from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import './Badges.scss';
import { MOBILE } from '../utils/widgetInfoDefaults';

const BadgeWrapper = ({ deviceType }) => {
	const [currentBadge, setCurrentBadge] = useState(null);
	const [popupHeight, setPopupHeight] = useState(0);
	const labels = useLabels();
	const pageScrollRef = useRef(null);
	const popupRef = useRef(null);

	const badgeData = {
		help: {
			name: 'help',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_to_Help_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_TO_HELP',
			title: 'COMMUNITY',
			topContent: 'SUBARU_LOVES_TO_HELP_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_TO_HELP_BOTTOM_CONTENT'
		},
		earth: {
			name: 'earth',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_the_Earth_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_THE_EARTH',
			title: 'ENVIRONMENT',
			topContent: 'SUBARU_LOVES_THE_EARTH_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_THE_EARTH_BOTTOM_CONTENT'
		},
		care: {
			name: 'care',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_to_Care_Vert_2Line_Ctr_1.png',
			badgeLabel: 'SUBARU_LOVES_TO_CARE',
			title: 'HEALTH',
			topContent: 'SUBARU_LOVES_TO_CARE_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_TO_CARE_BOTTOM_CONTENT'
		},
		learning: {
			name: 'learning',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_Learning_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_LEARNING',
			title: 'EDUCATION',
			topContent: 'SUBARU_LOVES_LEARNING_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_LEARNING_BOTTOM_CONTENT'
		},
		pets: {
			name: 'pets',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Loves_Pets_Vert_2Line_Ctr.png',
			badgeLabel: 'SUBARU_LOVES_PETS',
			title: 'PETS',
			topContent: 'SUBARU_LOVES_PETS_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVES_PETS_BOTTOM_CONTENT'
		},
		love: {
			name: 'love',
			image: 'https://images.dealer.com/subaru/love-promise/SOA_Subaru_Loves_2Line_Ctr%20(2)%202.png',
			badgeLabel: 'SUBARU_LOVE_PROMISE',
			title: 'SUBARU_LOVE_PROMISE_TOP_CONTENT',
			bottomContent: 'SUBARU_LOVE_PROMISE_BOTTOM_CONTENT'
		}
	};

	useEffect(() => {
		setPopupHeight(popupRef.current.getBoundingClientRect().height);
	}, [popupRef]);

	useEffect(() => {
		if (currentBadge !== null) {
			const scrollBlockType = deviceType === MOBILE ? 'center' : 'end';
			pageScrollRef.current.scrollIntoView({
				behavior: 'smooth',
				block: scrollBlockType,
				inline: 'nearest'
			});
		}
	}, [currentBadge, deviceType]);

	const handleBadgeClick = (badge) => {
		let badgeToSet = badge;
		if (currentBadge && badge?.name === currentBadge.name)
			badgeToSet = null;

		setCurrentBadge(badgeToSet);
	};

	const Badge = ({ name, label }) => {
		return (
			<button
				type="button"
				className={`lp-badge mx-sm-4 ${
					deviceType === MOBILE ? '' : 'w-14p'
				}`}
				onClick={() => handleBadgeClick(badgeData[name])}
			>
				<img src={badgeData[name].image} alt={labels.get(label)} />
				<p className="more-info">{labels.get('MORE_INFO')}</p>
			</button>
		);
	};

	const badgeProps = {
		label: propTypes.string.isRequired,
		name: propTypes.string.isRequired
	};

	Badge.propTypes = badgeProps;
	return (
		<div className="lp-badges" ref={popupRef}>
			<h3 className="lp-badges-header">
				{labels.getHTML('WHAT_IS_LOVE_PROMISE')}
			</h3>
			<p>{labels.get('LOVE_PROMISE_BADGE_CONTENT')}</p>
			<div className="lp-badge-container px-sm-4">
				{Object.keys(badgeData).map((badge) => (
					<Badge
						key={badge}
						name={badgeData[badge].name}
						label={badgeData[badge].badgeLabel}
					/>
				))}
			</div>

			<div
				role="presentation"
				className={`${
					deviceType === MOBILE
						? 'lp-badge-pop-up-mobile'
						: 'lp-badge-pop-up'
				} ${currentBadge?.name || ''}
				${!currentBadge ? 'd-none' : ''}`}
				style={{ top: popupHeight }}
				onClick={() => handleBadgeClick(null)}
				ref={pageScrollRef}
			>
				<button type="button" aria-label="Close">
					<i
						className="ddc-icon ddc-icon-remove2 ddc-icon-size-large"
						role="presentation"
						tabIndex="-1"
					/>
				</button>
				<h1>{labels.getHTML(currentBadge?.title || '')}</h1>
				<p className="top-content">
					{labels.getHTML(currentBadge?.topContent || '')}
				</p>
				<p className="bottom-content">
					{labels.getHTML(currentBadge?.bottomContent || '')}
				</p>
			</div>
		</div>
	);
};

const badgeWrapperProps = {
	deviceType: propTypes.string.isRequired
};

BadgeWrapper.propTypes = badgeWrapperProps;

export default BadgeWrapper;
